module.exports = __webpack_public_path__ + "static/media/up-arrow.50699325.svg";